import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=3a691dc7&scoped=true"
import script from "./dataDictionary.vue?vue&type=script&lang=js"
export * from "./dataDictionary.vue?vue&type=script&lang=js"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=3a691dc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a691dc7",
  null
  
)

export default component.exports